"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateCreateAnnouncementRequest = exports.AnnouncementSchema = void 0;
const yup = __importStar(require("yup"));
const ValidationError_1 = require("../errors/ValidationError");
const AnnouncementSchema = yup
    .object()
    .shape({
    subject: yup.string().required("Please enter the subject"),
    body: yup.string().required("Please enter the announcement content body"),
    files: yup
        .mixed()
        .nullable(true)
        .test("filesize", "Maximum limit for file upload is 20MB.", (value) => {
        let totalSize = 0;
        if (value) {
            Array.from(value).forEach((item) => {
                totalSize += item.size;
            });
        }
        return value && totalSize <= 20000000;
    })
        .test("type", "We only support pdf files.", (value) => {
        let success = true;
        if (value) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            Array.from(value).forEach((item) => {
                if (item.type) {
                    if (success && item.type && item.type !== "application/pdf") {
                        success = false;
                    }
                }
                else if (success && item.mimeType && item.mimeType !== "application/pdf") {
                    success = false;
                }
            });
        }
        return value && success;
    }),
    includeShareholders: yup.boolean().required(),
    includeNoteholders: yup.boolean().required(),
    includeOptionholders: yup.boolean().required(),
})
    .test("atLeastOne", "At least one type must be selected", (value) => value.includeShareholders || value.includeNoteholders || value.includeOptionholders);
exports.AnnouncementSchema = AnnouncementSchema;
/**
 * Validates create announcement method request schema
 * @param data: create announcement method request data {@link IAnnouncement} to validate
 */
const validateCreateAnnouncementRequest = (data) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        yield AnnouncementSchema.validate(data, {
            abortEarly: false,
        });
        return;
    }
    catch (err) {
        if (err instanceof yup.ValidationError) {
            const errorMessage = err.errors.toString();
            throw new ValidationError_1.ValidationError(errorMessage);
        }
        else {
            throw err;
        }
    }
});
exports.validateCreateAnnouncementRequest = validateCreateAnnouncementRequest;
//# sourceMappingURL=Announcement.js.map